module.exports = __webpack_public_path__ + "static/media/multiple-choice-columns-rocketeer.bbe5a8e6.svg";